import { atom } from 'jotai'

export type MainScrollTop = number

export const INITIAL_MAIN_SCRILL_TOP: MainScrollTop = 0
// 메인 페이지의 스크롤 위치
export const mainScrollTopAtom = atom<MainScrollTop>(INITIAL_MAIN_SCRILL_TOP)
